import MidiEffect from './MidiEffect.js';
import {AbstractParameter, IntegerParameter} from 'parameters/AbstractParameter.js';

class MidiCCEffect extends MidiEffect {
    constructor(track) {
        super("Midi CC", track);

        this.deviceNameParameter = new AbstractParameter(
            'deviceName', this, (o, x) => [],
            {
                defaultValue: null,
                unit: '',
                automatable: false,
            });

        this.registerParameter(this.deviceNameParameter);

        this.midiCCNumberParameter = new IntegerParameter(
            'midiCCNumber', this, (o, x) => [],
            {
                documentation: "The Midi CC number that will be sent on each trigger.",
                defaultValue: 0,
                min: 0,
                max: 119,
                unit: '',
            });

        this.registerParameter(this.midiCCNumberParameter);

        this.midiCCValueParameter = new IntegerParameter(
            'midiCCValueParameter', this, (o, x) => [],
            {
                documentation: "The value that will be sent to a given Midi CC on a each trigger",
                defaultValue: 0,
                min: 0,
                max: 128,
                unit: '',
            });

        this.registerParameter(this.midiCCValueParameter);
    }

    get documentation() {
        return "Sends a MIDI CC message on each trigger, with the CC number and value being configurable.";
    }

    output() {
        for (let i in this.triggers) {
            if (this.midiCC == undefined) {
                break;
            }

            this.midiCC.send(this.midiCCNumber, this.midiCCValue);
        }
        return this.triggers;
    }

    get midiCCNumber() {
        return this.midiCCNumberParameter.get();
    }

    get midiCCValue() {
        return this.midiCCValueParameter.get();
    }

    get midiCC() {
        return this.midi.deviceToMidiCC[this.deviceName];
    }

    get deviceName() {
        return this.deviceNameParameter.get();
    }

    get midi() {
        return this.track.sequencerEngine.midi;
    }

    getCopy(track, ignoreId=true) {
        let fx = new MidiCCEffect(track);
        fx.fromJson(this.getJson(), ignoreId);
        return fx;
    }
}

export default MidiCCEffect;
